const HOT = [255, 247, 220];
const GOLD = [
  [246, 184, 0],
  [255, 199, 39],
  [242, 169, 0],
  [255, 212, 90],
  [232, 154, 0],
];
const EMBER = [196, 110, 18];
const HALO_COLOR = 'rgb(255, 224, 138)';

const DRAG = 1.7;
const GRAVITY = 70;
const TRAIL_POINTS = 6;
const COLOR_STEPS = 32;
const SEEN_KEY = 'cb-fireworks-seen';
const POP_GAP = 1200;
const ATC_SELECTOR = '.main-product__atc-btn, [data-sticky-atc-btn]';
const ROCKET_FLIGHT = 0.65;
const ROCKET_TAIL = 0.14;
const EMBER_MAX = 320;
const EMBER_FIELDS = 6;

const random = (min, max) => min + Math.random() * (max - min);
const randomIndex = (length) => Math.floor(Math.random() * length);
const mix = (from, to, amount) => from.map((channel, index) => Math.round(channel + (to[index] - channel) * amount));
const toRgb = ([red, green, blue]) => `rgb(${red}, ${green}, ${blue})`;

const COLOR_TABLE = GOLD.map((gold) =>
  Array.from({ length: COLOR_STEPS + 1 }, (_, step) => {
    const progress = step / COLOR_STEPS;
    if (progress < 0.2) return toRgb(mix(HOT, gold, progress / 0.2));
    if (progress < 0.65) return toRgb(gold);
    return toRgb(mix(gold, EMBER, (progress - 0.65) / 0.35));
  })
);
const GLITTER_COLORS = GOLD.map((gold) => toRgb(mix(gold, HOT, 0.35)));

document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.querySelector('[data-fireworks-overlay]');
  const context = canvas?.getContext('2d');
  if (!canvas || !context) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    canvas.remove();
    return;
  }

  const { duration: durationValue, delay: delayValue, sectionId, atcBursts, designMode, rockets: rocketsValue } = canvas.dataset;
  const useRockets = rocketsValue === 'true';
  const total = (Number(durationValue) || 4800) / 1000;
  const delay = delayValue === undefined || delayValue === '' ? 400 : Number(delayValue);

  let running = false;
  let width = 0;
  let height = 0;
  let bigRadius = 0;
  let portrait = false;
  let focal = 0;
  let sparkScale = 1;
  let time = 0;
  let lastFrame = 0;
  let frameRequest = 0;
  let stopAt = 0;
  const groups = [];
  const flashes = [];
  const glitter = [];
  const plan = [];
  const rockets = [];
  const embers = new Float32Array(EMBER_MAX * EMBER_FIELDS);
  let emberNext = 0;
  let liveEmbers = 0;

  const resize = () => {
    const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = Math.round(width * pixelRatio);
    canvas.height = Math.round(height * pixelRatio);
    context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    context.lineCap = 'round';
    portrait = height > width * 1.2;
    bigRadius = portrait ? width * 0.55 : Math.max(140, Math.min(width, height) * 0.42);
    focal = bigRadius * 3;
    sparkScale = width < 700 || (navigator.hardwareConcurrency || 8) <= 4 ? 0.75 : 1;
  };

  const burst = (originX, originY, radius, count, depth = 0, delayInnerRing = false) => {
    const depthScale = focal / (focal + depth);
    flashes.push({ x: originX, y: originY, radius: radius * 0.5 * depthScale, life: 0.45, max: 0.45 });
    const gold = randomIndex(GOLD.length);
    const sparks = [];
    for (let index = 0; index < Math.round(count * sparkScale); index += 1) {
      const dz = random(-1, 1);
      const angle = random(0, Math.PI * 2);
      const ring = Math.sqrt(1 - dz * dz);
      const isOuter = Math.random() < 0.68;
      const speed = radius * DRAG * (isOuter ? random(0.85, 1) : random(0.3, 0.7));
      const life = random(1.6, 2.3);
      sparks.push({
        x: 0,
        y: 0,
        z: depth,
        vx: Math.cos(angle) * ring * speed,
        vy: Math.sin(angle) * ring * speed,
        vz: dz * speed,
        trail: new Float32Array(TRAIL_POINTS * 2),
        trailHead: 0,
        trailCount: 0,
        scale: 1,
        life,
        max: life,
        colors: COLOR_TABLE[Math.random() < 0.8 ? gold : randomIndex(GOLD.length)],
        lineWidth: isOuter ? random(2.2, 3) : random(1.6, 2.2),
        wait: delayInnerRing && !isOuter ? 0.05 : 0,
        twinkles: Math.random() < 0.35,
      });
    }
    sparks.sort((a, b) => b.vz - a.vz);
    const group = { depth, originX, originY, sparks };
    const insertAt = groups.findIndex((existing) => existing.depth < depth);
    groups.splice(insertAt === -1 ? groups.length : insertAt, 0, group);

    for (let index = 0; index < count * sparkScale * 0.3; index += 1) {
      const dz = random(-1, 1);
      const angle = random(0, Math.PI * 2);
      const ring = Math.sqrt(1 - dz * dz);
      const distance = radius * random(0.4, 1.05);
      const scale = focal / (focal + depth + dz * distance);
      glitter.push({
        x: originX + Math.cos(angle) * ring * distance * scale,
        y: originY + Math.sin(angle) * ring * distance * scale,
        scale,
        born: time + random(0.45, 1.05),
        life: random(0.8, 1.4),
        size: random(1.4, 2.8),
        color: GLITTER_COLORS[randomIndex(GOLD.length)],
      });
    }
  };

  const finish = () => {
    running = false;
    cancelAnimationFrame(frameRequest);
    window.removeEventListener('resize', resize);
    groups.length = 0;
    flashes.length = 0;
    glitter.length = 0;
    plan.length = 0;
    rockets.length = 0;
    embers.fill(0);
    canvas.classList.add('is-done');
    setTimeout(() => {
      if (!running) canvas.hidden = true;
    }, 450);
  };

  const compact = (list, keep) => {
    let write = 0;
    for (let read = 0; read < list.length; read += 1) {
      if (keep(list[read])) list[write++] = list[read];
    }
    list.length = write;
  };

  let dragFactor = 1;
  let gravityStep = 0;
  let delta = 0;
  let liveSparks = 0;

  const updateSpark = (spark, group) => {
    if (spark.wait > 0) {
      spark.wait -= delta;
      liveSparks += 1;
      return true;
    }
    spark.life -= delta;
    if (spark.life <= 0) return false;
    spark.vx *= dragFactor;
    spark.vy = spark.vy * dragFactor + gravityStep;
    spark.vz *= dragFactor;
    spark.x += spark.vx * delta;
    spark.y += spark.vy * delta;
    spark.z += spark.vz * delta;
    const scale = focal / (focal + spark.z);
    spark.scale = scale;
    const slot = spark.trailHead * 2;
    spark.trail[slot] = group.originX + spark.x * scale;
    spark.trail[slot + 1] = group.originY + spark.y * scale;
    spark.trailHead = (spark.trailHead + 1) % TRAIL_POINTS;
    if (spark.trailCount < TRAIL_POINTS) spark.trailCount += 1;
    liveSparks += 1;
    return true;
  };

  const rocketAt = (rocket, elapsed) => {
    const progress = Math.min(Math.max(elapsed / rocket.flight, 0), 1);
    const eased = 1 - (1 - progress) * (1 - progress);
    return [
      rocket.x0 + (rocket.x1 - rocket.x0) * eased + Math.sin(progress * Math.PI * 3) * rocket.wobble,
      rocket.y0 + (rocket.y1 - rocket.y0) * eased,
    ];
  };

  const launch = (x, y, depth) => {
    const depthScale = focal / (focal + depth);
    rockets.push({
      x0: x + random(-0.04, 0.04) * width,
      y0: height + 12,
      x1: x,
      y1: y,
      born: time,
      flight: ROCKET_FLIGHT,
      wobble: random(1, 3),
      scale: depthScale,
    });
  };

  const emit = (x, y, scale) => {
    const slot = emberNext * EMBER_FIELDS;
    const life = random(0.35, 0.7);
    embers[slot] = x + random(-1.5, 1.5);
    embers[slot + 1] = y;
    embers[slot + 2] = random(-25, 25) * scale;
    embers[slot + 3] = random(10, 70) * scale;
    embers[slot + 4] = life;
    embers[slot + 5] = life;
    emberNext = (emberNext + 1) % EMBER_MAX;
  };

  const stepEmbers = () => {
    liveEmbers = 0;
    for (let slot = 0; slot < embers.length; slot += EMBER_FIELDS) {
      if (embers[slot + 4] <= 0) continue;
      embers[slot + 4] -= delta;
      embers[slot + 3] += GRAVITY * 2 * delta;
      embers[slot] += embers[slot + 2] * delta;
      embers[slot + 1] += embers[slot + 3] * delta;
      if (embers[slot + 4] > 0) liveEmbers += 1;
    }
  };

  const step = () => {
    time += delta;
    while (plan.length && plan[0].at <= time) plan.shift().run();

    dragFactor = Math.exp(-DRAG * delta);
    gravityStep = GRAVITY * delta;
    liveSparks = 0;
    for (const group of groups) compact(group.sparks, (spark) => updateSpark(spark, group));
    compact(groups, (group) => group.sparks.length > 0);
    compact(flashes, (flash) => {
      flash.life -= delta;
      return flash.life > 0;
    });
    compact(glitter, (star) => time <= star.born + star.life);
    compact(rockets, (rocket) => {
      const elapsed = time - rocket.born;
      if (elapsed >= rocket.flight) return false;
      const [x, y] = rocketAt(rocket, elapsed);
      emit(x, y, rocket.scale);
      if (Math.random() < 0.5) emit(x, y, rocket.scale);
      return true;
    });
    stepEmbers();

    if ((!plan.length && !liveSparks && !glitter.length && !rockets.length && !liveEmbers) || time > stopAt) finish();
  };

  const drawFlash = (flash) => {
    const fade = flash.life / flash.max;
    const glow = context.createRadialGradient(flash.x, flash.y, 0, flash.x, flash.y, flash.radius);
    glow.addColorStop(0, `rgba(255, 248, 214, ${0.95 * fade})`);
    glow.addColorStop(0.25, `rgba(255, 214, 90, ${0.55 * fade})`);
    glow.addColorStop(1, 'rgba(255, 200, 60, 0)');
    context.globalAlpha = 1;
    context.fillStyle = glow;
    context.beginPath();
    context.arc(flash.x, flash.y, flash.radius, 0, Math.PI * 2);
    context.fill();
  };

  const traceTrail = (spark, from) => {
    const { trail, trailHead, trailCount } = spark;
    const oldest = (trailHead - trailCount + TRAIL_POINTS) % TRAIL_POINTS;
    for (let index = from; index < trailCount; index += 1) {
      const slot = ((oldest + index) % TRAIL_POINTS) * 2;
      if (index === from) context.moveTo(trail[slot], trail[slot + 1]);
      else context.lineTo(trail[slot], trail[slot + 1]);
    }
  };

  const drawSpark = (spark) => {
    if (spark.wait > 0 || spark.trailCount < 2) return;
    const remaining = spark.life / spark.max;
    const nearness = Math.min(Math.max((spark.scale - 0.75) / 0.75, 0), 1);
    let alpha = Math.min(1, remaining * 1.6) * (0.45 + 0.55 * nearness);
    if (spark.twinkles && remaining < 0.4 && Math.random() < 0.5) alpha *= 0.25;
    const coreWidth = spark.lineWidth * spark.scale * (0.5 + 0.5 * remaining);
    const split = Math.max(spark.trailCount - 3, 0);

    context.beginPath();
    traceTrail(spark, 0);
    context.globalAlpha = alpha * 0.18;
    context.strokeStyle = HALO_COLOR;
    context.lineWidth = coreWidth * 2.6;
    context.stroke();

    context.strokeStyle = spark.colors[Math.min(COLOR_STEPS, Math.round((1 - remaining) * COLOR_STEPS))];
    context.lineWidth = coreWidth;
    if (split > 0) {
      context.beginPath();
      traceTrail(spark, 0);
      context.globalAlpha = alpha * 0.4;
      context.stroke();
    }
    context.beginPath();
    traceTrail(spark, split);
    context.globalAlpha = alpha;
    context.stroke();
  };

  const drawGlitter = (star) => {
    if (time < star.born) return;
    const swell = Math.sin(((time - star.born) / star.life) * Math.PI);
    const reach = star.size * star.scale * (0.8 + swell) * 2.2;
    const nearness = Math.min(Math.max((star.scale - 0.75) / 0.75, 0), 1);
    context.globalAlpha = swell * (0.6 + 0.4 * Math.random()) * (0.5 + 0.5 * nearness);
    context.fillStyle = star.color;
    context.beginPath();
    context.moveTo(star.x, star.y - reach);
    context.quadraticCurveTo(star.x, star.y, star.x + reach, star.y);
    context.quadraticCurveTo(star.x, star.y, star.x, star.y + reach);
    context.quadraticCurveTo(star.x, star.y, star.x - reach, star.y);
    context.quadraticCurveTo(star.x, star.y, star.x, star.y - reach);
    context.fill();
  };

  const drawRocket = (rocket) => {
    const elapsed = time - rocket.born;
    const [headX, headY] = rocketAt(rocket, elapsed);
    const [tailX, tailY] = rocketAt(rocket, elapsed - ROCKET_TAIL);
    const streak = context.createLinearGradient(tailX, tailY, headX, headY);
    streak.addColorStop(0, 'rgba(242, 169, 0, 0)');
    streak.addColorStop(1, 'rgba(255, 212, 90, 0.95)');
    context.globalAlpha = 1;
    context.strokeStyle = streak;
    context.lineWidth = 2.6 * rocket.scale;
    context.beginPath();
    context.moveTo(tailX, tailY);
    context.lineTo(headX, headY);
    context.stroke();

    context.fillStyle = HALO_COLOR;
    context.globalAlpha = 0.35;
    context.beginPath();
    context.arc(headX, headY, 6 * rocket.scale, 0, Math.PI * 2);
    context.fill();
    context.fillStyle = toRgb(HOT);
    context.globalAlpha = 1;
    context.beginPath();
    context.arc(headX, headY, 2.2 * rocket.scale, 0, Math.PI * 2);
    context.fill();
  };

  const drawEmbers = () => {
    context.fillStyle = GLITTER_COLORS[0];
    for (let slot = 0; slot < embers.length; slot += EMBER_FIELDS) {
      const life = embers[slot + 4];
      if (life <= 0) continue;
      context.globalAlpha = life / embers[slot + 5];
      context.fillRect(embers[slot] - 1, embers[slot + 1] - 1, 2, 2);
    }
  };

  const draw = () => {
    context.clearRect(0, 0, width, height);
    drawEmbers();
    for (const rocket of rockets) drawRocket(rocket);
    for (const flash of flashes) drawFlash(flash);
    for (const group of groups) {
      for (const spark of group.sparks) drawSpark(spark);
    }
    for (const star of glitter) drawGlitter(star);
    context.globalAlpha = 1;
  };

  const frame = (now) => {
    if (!running) return;
    delta = lastFrame ? Math.min(0.033, (now - lastFrame) / 1000) : 0.016;
    lastFrame = now;
    step();
    if (!running) return;
    draw();
    frameRequest = requestAnimationFrame(frame);
  };

  const schedule = (bursts) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!running) {
      running = true;
      time = 0;
      lastFrame = 0;
      stopAt = 0;
      canvas.hidden = false;
      canvas.classList.remove('is-done');
      resize();
      window.addEventListener('resize', resize, { passive: true });
      frameRequest = requestAnimationFrame(frame);
    }
    for (const entry of bursts(width, height)) plan.push({ at: time + entry.at, run: entry.run });
    plan.sort((a, b) => a.at - b.at);
    stopAt = Math.max(stopAt, plan[plan.length - 1].at + total);
  };

  const SHOW_PORTRAIT = [
    { at: 0.05, x: 0.5, y: 0.4, size: 1, sparks: 220, depth: 0, innerRing: true },
    { at: 0.5, x: 0.3, y: 0.7, size: 0.85, sparks: 170, depth: 0.08, innerRing: true },
    { at: 0.8, x: 0.7, y: 0.18, size: 0.8, sparks: 160, depth: 0.12, innerRing: true },
    { at: 1, x: 0.22, y: 0.14, size: 0.6, sparks: 90, depth: 0.25 },
    { at: 1.5, x: 0.78, y: 0.55, size: 0.6, sparks: 90, depth: 0.3 },
    { at: 2, x: 0.65, y: 0.86, size: 0.55, sparks: 80, depth: 0.2 },
    { at: 2.5, x: 0.3, y: 0.42, size: 0.5, sparks: 70, depth: 0.4 },
  ];
  const SHOW_LANDSCAPE = [
    { at: 0.05, x: 0.5, y: 0.45, size: 1, sparks: 220, depth: 0, innerRing: true },
    { at: 0.5, x: 0.23, y: 0.55, size: 0.75, sparks: 160, depth: 0.08, innerRing: true },
    { at: 0.8, x: 0.77, y: 0.37, size: 0.7, sparks: 150, depth: 0.12, innerRing: true },
    { at: 1, x: 0.18, y: 0.23, size: 0.5, sparks: 80, depth: 0.25 },
    { at: 1.5, x: 0.84, y: 0.4, size: 0.46, sparks: 75, depth: 0.35 },
    { at: 2, x: 0.38, y: 0.75, size: 0.42, sparks: 65, depth: 0.2 },
    { at: 2.5, x: 0.68, y: 0.11, size: 0.38, sparks: 60, depth: 0.45 },
  ];

  const play = () =>
    schedule((w, h) =>
      (portrait ? SHOW_PORTRAIT : SHOW_LANDSCAPE).flatMap((shot) => {
        const x = w * shot.x;
        const y = h * shot.y;
        const depth = focal * shot.depth;
        const fire = () => burst(x, y, bigRadius * shot.size, shot.sparks, depth, shot.innerRing);
        if (!useRockets) return [{ at: shot.at, run: fire }];
        return [
          { at: shot.at, run: () => launch(x, y, depth) },
          { at: shot.at + ROCKET_FLIGHT, run: fire },
        ];
      })
    );

  const pop = (originX, originY) =>
    schedule((w, h) => {
      const x = originX ?? w / 2;
      const y = originY ?? h * 0.35;
      const side = x > w / 2 ? -1 : 1;
      return [
        { at: 0, run: () => burst(x, y, bigRadius * 0.6, 120, 0, true) },
        { at: 0.35, run: () => burst(x + side * w * random(0.15, 0.25), y + h * random(-0.1, 0.05), bigRadius * 0.4, 60, focal * 0.25) },
      ];
    });

  window.CleevoBurst = { play, pop };

  document.addEventListener('shopify:section:select', (event) => {
    if (event.detail?.sectionId === sectionId) play();
  });

  const seen = () => {
    try {
      return window.sessionStorage.getItem(SEEN_KEY) === '1';
    } catch {
      return false;
    }
  };

  const markSeen = () => {
    try {
      window.sessionStorage.setItem(SEEN_KEY, '1');
    } catch {
    }
  };

  const autoplay = () => {
    if (designMode !== 'true') {
      if (seen()) return;
      markSeen();
    }
    setTimeout(play, delay);
  };

  autoplay();

  if (atcBursts === 'true') {
    let lastPopAt = 0;
    document.addEventListener('click', (event) => {
      const button = event.target.closest(ATC_SELECTOR);
      if (!button || button.disabled || performance.now() - lastPopAt < POP_GAP) return;
      lastPopAt = performance.now();
      const rect = button.getBoundingClientRect();
      pop(rect.left + rect.width / 2, Math.max(rect.top - 40, window.innerHeight * 0.2));
    }, true);
  }
});
